import React from 'react';
import LeaveOrganizationLink from '../LeaveOrganizationLink';
import DeleteUserLink from '../DeleteUserLink';

type Props = {
  organizationUser: {
    id: string;
    currentUser: boolean;
    confirmedWithSignature: boolean;
    firstName: string;
    secondName: string;
  };
  isCurrentUserConfirmedWithSignature: boolean;
  handleUsersChange: () => void;
};

const ActionCell: React.FC<Props> = ({ organizationUser, isCurrentUserConfirmedWithSignature, handleUsersChange }) => {
  if (organizationUser.currentUser) {
    return (
      <LeaveOrganizationLink />
    );
  }

  if (isCurrentUserConfirmedWithSignature) {
    return (
      <DeleteUserLink organizationUser={organizationUser} handleUsersChange={handleUsersChange}/>
    );
  }

  if (organizationUser.confirmedWithSignature) {
    return <i>Удалить может только подтвержденный ЭП пользователь организации</i>;
  }

  return (
    <DeleteUserLink organizationUser={organizationUser} handleUsersChange={handleUsersChange}/>
  );
};

export default ActionCell;
